import React from 'react';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';

import './Results.css';

import { IMitekFlowComponentProps } from '../MitekFlow';
import { useMitekContext } from '../../../providers/MitekProvider/MitekProvider';
import { Button, Row, Col, Image, Container } from '../../../importCL';

export interface IMitekFlowResultProps  extends IMitekFlowComponentProps{
    descriptionCheckbox ?: boolean;

    subtitleDescription ?: string;
    subtitleDescriptionCheckbox ?: boolean;
    ctaButtonLink ?: string;
    ctaButtonCheckbox ?: boolean;

    ctaButtonText?: string;
    setFlowStage:  THandlerFunction;
    isRetake?: boolean;
    usingHardReset?: boolean;
}

const Results = (props: IMitekFlowResultProps): JSX.Element => {
    const { clearResults } = useMitekContext();

    return (
        <Container id='mitek-result' className='MitekFlowResults MitekFlowResults__container'>
            {props.mainTitle && 
                <Row className='MitekFlowResults__row'>
                    <Col className='MitekFlowResults__col'>
                        <div className='MitekFlowResults__mainTitle'>
                            {transformHTMLParserLinks(props.mainTitle)}
                        </div>
                    </Col>
                </Row>
            }
            {props.subtitle && 
                <Row className='MitekFlowResults__row'>
                    <Col className='MitekFlowResults__col'>
                        <div
                            className={`MitekFlowResults__subtitle${!props.descriptionCheckbox ? '--spacer' : ''
                            }`}
                        >
                            {transformHTMLParserLinks(props.subtitle)}
                        </div>
                    </Col>
                </Row>
            }
            {props.subtitleDescriptionCheckbox && props.subtitleDescription && 
                <Row className='MitekFlowResults__row'>
                    <Col className='MitekFlowResults__col'>
                        <div className='MitekFlowResults__subtitleDescription'>
                            {transformHTMLParserLinks(props.subtitleDescription)}
                        </div>
                    </Col>
                </Row>
            }
            {props.imgPath && (
                <Row className='MitekFlowResults__row'>
                    <Col className='MitekFlowResults__col'>
                        <Image
                            loading='lazy'
                            className='MitekFlowResults__image'
                            src={props.imgPath}
                            alt={props.imgAltText}
                        />
                    </Col>
                </Row>
            )}
            {props.descriptionCheckbox && props.description && (
                <div className='MitekFlowResults__description'>
                    {transformHTMLParserLinks(props.description)}
                </div>
            )}
            {props.isRetake && (
                <div
                    className={`MitekFlowResults__ctaButton--div${props.descriptionCheckbox ? 'WithDescription' : 'NoDescription'
                    }`}
                >
                    <Button
                        className='MitekFlowResults__ctaButton'
                        size='medium'
                        onClick={() => {
                            if (props.usingHardReset) {
                                window.location.reload();
                            } else {
                                clearResults();
                                props.setFlowStage('SelectID');
                            }
                        }}
                    >
                        Retake
                    </Button>
                </div>
            )}
        </Container>
    );
};

export default Results;
